import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../Styles/Feestructure.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import Spinner from "react-bootstrap/Spinner";
import ScaleLoader from "react-spinners/ScaleLoader";
// Note: Ensure simplePostCall and ApiConfig are imported or available globally
// import { simplePostCall } from "../../Services/ApiServices";
// import { ApiConfig } from "../../Config/ApiConfig";

export default function Feestructure() {
  // 1. Added missing state for studentList (or academicYears)
  const [academicYears, setAcademicYears] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const viewBtnStyle = {
    fontSize: "13px",
    padding: "6px 12px",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
  };

  const iconStyle = {
    fontSize: "14px",
  };

  useEffect(() => {
    loadDataStudentFee();
  }, []);

  const loadDataStudentFee = async (searchQuery = "") => {
    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");

    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      academic: searchQuery,
    };

    try {
      // Using your simplePostCall logic
      const response = await simplePostCall(
        ApiConfig.feeStructurelist,
        JSON.stringify(requestBody),
      );

      if (response?.result && response?.data) {
        // Set the academic year data from the API
        setAcademicYears(response.data);
      } else {
        setAcademicYears([]);
      }
    } catch (error) {
      console.error("Error loading student list:", error);
      setAcademicYears([]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="feestruc-container my-4">
      <div className="special-header panel-white-all mb-4">
        <h4 className="page-title mt-1">Fee Structures</h4>
      </div>

      <div className="row feestruct-cardbg">
        {isLoading ? (
          <div className="col-12 text-center">
            <ScaleLoader
              color="#F4BB44"
              style={{ textAlign: "center", padding: "10px" }}
            />
          </div>
        ) : academicYears.length > 0 ? (
          // 2. Map through the API data to create cards dynamically
          academicYears.map((item, index) => (
            <div className="col-md-12 col-lg-4 col-sm-12 mb-4" key={index}>
              <div
                className={`card feestruc-cardss-${(index % 2) + 1} text-center`}
              >
                <div className="card-body">
                  <h5 className="card-title">
                    <b>{item.academic_year_name}</b>
                  </h5>
                  <div className="card-text">
                    <p className="mb-1">
                      Start Date:{" "}
                      {new Date(item.academic_year_start_date).toDateString()}
                    </p>
                    <p>
                      End Date:{" "}
                      {new Date(item.academic_year_end_date).toDateString()}
                    </p>
                  </div>
                  <Link
                    to={`/firstcard/${item.academic_year_id}`}
                    className="btn"
                    style={viewBtnStyle}
                  >
                    <i
                      className="bi bi-arrow-up-right-square-fill"
                      style={iconStyle}
                    ></i>
                    View
                  </Link>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 text-center">
            <p>No fee structures found.</p>
          </div>
        )}
      </div>
    </div>
  );
}
